module.exports = __webpack_public_path__ + "img/Leap Learning Lab Training Guide.9d15f9de.png";